import { getOperationAST } from 'graphql';
import isPromise from 'is-promise';
import DataLoader from 'dataloader';
import { mergeExecutionParams } from './mergeExecutionParams';
import { splitResult } from './splitResult';
export function createBatchingExecutor(executor, dataLoaderOptions, extensionsReducer) {
    const loader = new DataLoader(createLoadFn(executor, extensionsReducer !== null && extensionsReducer !== void 0 ? extensionsReducer : defaultExtensionsReducer), dataLoaderOptions);
    return (executionParams) => loader.load(executionParams);
}
function createLoadFn(executor, extensionsReducer) {
    return async (execs) => {
        const execBatches = [];
        let index = 0;
        const exec = execs[index];
        let currentBatch = [exec];
        execBatches.push(currentBatch);
        const operationType = getOperationAST(exec.document, undefined).operation;
        while (++index < execs.length) {
            const currentOperationType = getOperationAST(execs[index].document, undefined).operation;
            if (operationType === currentOperationType) {
                currentBatch.push(execs[index]);
            }
            else {
                currentBatch = [execs[index]];
                execBatches.push(currentBatch);
            }
        }
        let containsPromises = false;
        const executionResults = [];
        execBatches.forEach(execBatch => {
            const mergedExecutionParams = mergeExecutionParams(execBatch, extensionsReducer);
            const executionResult = executor(mergedExecutionParams);
            if (isPromise(executionResult)) {
                containsPromises = true;
            }
            executionResults.push(executionResult);
        });
        if (containsPromises) {
            return Promise.all(executionResults).then(resultBatches => {
                let results = [];
                resultBatches.forEach((resultBatch, index) => {
                    results = results.concat(splitResult(resultBatch, execBatches[index].length));
                });
                return results;
            });
        }
        let results = [];
        executionResults.forEach((resultBatch, index) => {
            results = results.concat(splitResult(resultBatch, execBatches[index].length));
        });
        return results;
    };
}
function defaultExtensionsReducer(mergedExtensions, executionParams) {
    const newExtensions = executionParams.extensions;
    if (newExtensions != null) {
        Object.assign(mergedExtensions, newExtensions);
    }
    return mergedExtensions;
}
//# sourceMappingURL=createBatchingExecutor.js.map